module.exports = __webpack_public_path__ + "img/background-destination-tablet.9b36d58f.jpg";